export default __webpack_public_path__ + "static/footer-shape-e90d09bc7f7ae6ef89b40b9d139d3a87.png";